// Libs
import React, { useEffect, useState } from 'react';
import { ReactElement } from 'react';
// App
import styles from './sub-filters.module.scss';
import { Icon, ToggleButton, ToggleButtonGroup, useMediaQuery, useTheme } from 'ui-components';
import { DISPLAYED_DURATIONS, TIME_PERIODS_CONFIG } from './filters.constants';
import { SubFiltersProps } from './sub-filters.interfaces';

const SubFilters = (props: SubFiltersProps): ReactElement => {
  const {
    className,
    endDate,
    timePeriod,
    onChange,
    onClickPrevious,
    onClickNext,
    shouldShowPreviousButton,
    shouldShowNextButton,
  } = props;
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const config = TIME_PERIODS_CONFIG(isSmallScreen)[timePeriod];
  const { eachPeriodOfIntervalHandler, isSamePeriodHandler, formatHandler, subPeriodsHandler } = config;
  const startDate = subPeriodsHandler(endDate, DISPLAYED_DURATIONS[timePeriod]);
  const [selectedFilter, setSelectedFilter] = useState(endDate);
  const dates = eachPeriodOfIntervalHandler({
    start: startDate,
    end: endDate,
  });

  /**
   * Applies changes in local state when provided value change
   */
  useEffect(() => {
    setSelectedFilter(endDate);
  }, [endDate]);

  /**
   * Event fired on filter item click
   * @param filter the filter clicked
   */
  const handleSelectFilter = (filter: Date) => {
    setSelectedFilter(filter);

    onChange && onChange(filter);
  };

  return (
    <ToggleButtonGroup standaloneButtons={false} direction="row" exclusive={true} className={className}>
      {shouldShowPreviousButton && (
        <ToggleButton
          className={styles.button}
          color="secondary"
          size="small"
          value="left"
          onClick={onClickPrevious}
          selected={false}
        >
          <Icon name="left-arrow" size="medium" color="tertiary" />
        </ToggleButton>
      )}
      {dates.map((date: Date, index: number) => {
        const isFirstDate = index == 0;
        const isLastDate = index == dates.length - 1;

        return (
          <ToggleButton
            key={index}
            className={styles.button}
            color="secondary"
            size="small"
            value={date}
            onClick={() => handleSelectFilter(date)}
            selected={isSamePeriodHandler(selectedFilter, date)}
          >
            {formatHandler(date, isFirstDate, isLastDate)}
          </ToggleButton>
        );
      })}
      {shouldShowNextButton && (
        <ToggleButton
          className={styles.button}
          color="secondary"
          size="small"
          value="left"
          onClick={onClickNext}
          selected={false}
        >
          <Icon name="right-arrow" size="medium" color="tertiary" />
        </ToggleButton>
      )}
    </ToggleButtonGroup>
  );
};

export default SubFilters;
